import { render, staticRenderFns } from "./Statistical-graph.vue?vue&type=template&id=2c55735f&scoped=true"
import script from "./Statistical-graph.vue?vue&type=script&lang=js"
export * from "./Statistical-graph.vue?vue&type=script&lang=js"
import style0 from "./Statistical-graph.vue?vue&type=style&index=0&id=2c55735f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55735f",
  null
  
)

export default component.exports